export const normalizeCreditText = (value) => typeof value === "string"
  && /created|maintained|crafted|developed|powered|managed by|campus connect\s*&/i.test(value)
  ? value.replace(/\b(?:dosa|doso) office\b/gi, "Office of Student Affairs") : value;

export const normalizeCreditConfig = (value) => {
  if (Array.isArray(value)) return value.map(normalizeCreditConfig);
  if (value && typeof value === "object") {
    const result = Object.fromEntries(
      Object.entries(value).map(([key, item]) => [key, normalizeCreditConfig(item)]),
    );
    if (value.id === "maintained" || /^maintained by$/i.test(value.label || "")) {
      result.lines = (result.lines || []).map((line) => typeof line === "string"
        ? line.replace(/\b(?:dosa|doso) office\b/gi, "Office of Student Affairs") : line);
    }
    return result;
  }
  return normalizeCreditText(value);
};
